import { render } from "./AssetRoiReport.vue?vue&type=template&id=487b15c4"
import script from "./AssetRoiReport.vue?vue&type=script&lang=js"
export * from "./AssetRoiReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__